import styled from 'styled-components';

export const CustomerDetailsSummaryRoot = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 1.5rem;
    background: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    box-shadow: 0 0 0.75rem rgba(0, 0, 0, 0.25);
    border-radius: 0.5rem;
`;

export const CustomerDetailsSummaryFields = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
`;

export const CustomerDetailsSummaryField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;
